var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MainBanner'),_c('div',[_c('Gajotsavam')],1),_c('div',[_c('Banner')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }